import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const CreateChatGroupModal = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  min-height: 634px;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.50)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    z-index: 200;
    background-color: var(--white);
    width: 1038px;
    margin: auto;
    max-height: 80%;
    border-radius: 14px;
    box-sizing: border-box;
    &--response {
      padding: 40px;
    }
    .header {
      display: flex;
      padding: 10px 20px 8px;
      border-bottom: 1px solid #E0E6ED;
      align-items: center;
      .title {
        display: flex;
        align-items: center;
        color: #1F1F52;
        font-size: 17px;
      }
      .close {
        height: 23px;
        width: 23px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #6D6DB91F;
        cursor: pointer;
        outline: none;
        border: none;
        color: #36369B;
        font-size: 6px;
        margin-right: 5px;
      }
    }
    .footer {
      display: flex;
      padding: 16px 20px;
      justify-content: space-between;
      border-top: 2px solid #F0EFF9;
      &__description {
        align-items: center;
        &-icon {
          margin-right: 10px;
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #3E3DA3;
        }
        &-text {
          display: flex;
          font-family: Nunito Sans;
          font-size: 17px;
          color: #707582;
          height: 100%;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .button-status {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #36369B;
        color: #FFF;
        font-size: 14px;
        font-family: Nunito Sans;
        padding: 8px 36px;
        border-radius: 75px;
        cursor: pointer;
        border: none;
        outline: none;
        &__icon {
          margin-right: 10px;
          opacity: 0.4;
          font-size: 20px;
          &--back {
            font-size: 13px;
          }
        }
        &--green {
          background-color: #00A600;
        }
        &--blue {
          background-color: #2E2CBF;
        }
        &--secondary {
          color: #2E2CBF;
          background-color: #F0F0FF;
        }
        &--disabled {
          background-color: #EEEDF4;
          color: #707582;
          cursor: default;
        }
      }
    }

    .content {
      height: calc(100% - 42px - 66.33px);
      min-height: 600px; 
      overflow: auto;
      padding: 20px;
      box-sizing: border-box;
      &__chat-image {
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #E0E0FC;
        margin-bottom: 20px;  
        .image-preview {
          width: 70px;
          height: 70px;
          border-radius: 20px;
          background-color: #C6C5FF;
          object-fit: cover;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          i {
            margin: auto;
            font-size: 30px;
            color: #6C6BCC;

          }
        }
        .image-text {
          align-self: center;
          margin-left: 20px;
          font-family: Nunito Sans;
          &__name {
            font-family: Nunito Sans;
            font-size: 20px;
            color: #707582;
          }
          &__upload {
            font-family: Nunito Sans Bold;
            font-size: 17px;
            color: #2E2CBF;
            cursor: pointer;
          }
        }
      }
      &__inputs {
        .double-content {
          display: flex;
          padding-bottom: 20px;
          border-bottom: 1px solid #E0E0FC;
          margin-bottom: 20px;
        } 
        .field {
          width: 100%;  
          &__label {
            font-family: Nunito Sans;
            font-size: 17px;
            color: #3E3E5B;
            margin-bottom: 7.5px;
            display: flex;
          }
          &--select {
            margin-left: 20px;
          }
        }
      }

      .users-list {
        display: flex;
        flex-wrap: wrap;
        padding-top: 20px;
        overflow-y: scroll;
        height: 430px;
        align-items: flex-start;
        align-content: flex-start;
        padding: 0 60px;
        justify-content: center;
        ::-webkit-scrollbar {
          width: 25px;
        }
        ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 10px 10px transparent;
          /* margin: 1px 0px;  */
        }
        ::-webkit-scrollbar-thumb {
          border: 10px solid rgba(0, 0, 0, 0);
          box-shadow: inset 0 0 10px 10px #3E3DA366;
          background-clip: padding-box;
          border-radius: 9999px;
          background-color: transparent;
        }
        &__responses {
          height: 100%;
          text-align: center;
          margin: auto;
          padding-left: 28px;
          display: flex;
        }
        .user-item {
          width: 270px;
          display: flex;
          padding: 8.5px 20px;
          border-radius: 12px;
          margin-bottom: 20px;
          background: #FCFCFE;
          align-items: center;
          color: #1F1F52;
          margin: 0 10px 20px;
          cursor: pointer;
          :nth-child(odd) {
            margin-right: 10px;
          }
          &--selected {
            color: #FCFCFE;
            background-color: #6C6BCC;
          }
          &__info {
            margin-left: 10px;
          }
          &__name {
            font-size: 17px;
            font-family: "Nunito Sans";
          }
          &__program {
            color: #68688D;
            font-family: "Nunito Sans";
            font-size: 12px;
            &--selected {
              color: #FCFCFE;
            }
          }
        }
      }

      .chat-info {
        text-align: center;
        margin-bottom: 40px;
        &__label {
          color: #3E3E5B;
          font-size: 17px;
          font-family: Nunito Sans;
        }
        &__name {
          font-family: Nunito Sans;
          color: #1F1F52;
          font-size: 20px;
        }
      }
    }
  }  
  
`;